import React, { useRef, useEffect, useState, useCallback } from 'react';
import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
	Flex,
	Icon,
	Text,
	Button,
	SimpleGrid,
	Divider,
	Table,
	Thead,
	Tr,
	Th,
	Tbody,
	Td,
	Tfoot,
	Avatar,
	Stack,
	Spinner,
	Image,
	Accordion,
	AccordionItem,
	AccordionButton,
	AccordionIcon,
	AccordionPanel,
	useToast,
	FormLabel,
	Switch,
} from '@chakra-ui/react';
import { FormHandles } from '@unform/core';
import { v4 as uuid } from 'uuid';
import { format } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';
import { FiArrowRight, FiCheckCircle, FiMinus, FiPlus, FiSearch, FiTrash2 } from 'react-icons/fi';
import * as Yup from 'yup';

import api from '../../../services/api';
import { useAuth } from '../../../hooks/auth';
import { formatPrice } from '../../../utils/format';
import { AppError } from '../../../utils/AppError';
import load from '../../../assets/loading/tres_pontos.gif';
import formatInputMoeda from '../../../utils/formatInputMoeda';
import formatPriceNumber from '../../../utils/formatPriceNumber';
import getValidationErrors from '../../../utils/getValidationErrors';
import Input from '../../Inputs/Input';
import InputTextArea from '../../Inputs/inputTextArea';
import InputDate from '../../Inputs/InputDate';
import SelectInput from '../../Inputs/Selects/SelectInput';
import ModalCadastroCliente from '../../ModalCadastroCliente';
import Alert from '../../Alert';
import { FinJsonDTO } from '../../../dtos/FinJsonDTO';
import { ClienteDTO } from '../../../dtos/ClienteDTO';
import { ContaDTO } from '../../../dtos/ContaDTO';
import { OperacaoDTO } from '../../../dtos/OperacaoDTO';
import { CaixaDTO } from '../../../dtos/CaixaDTO';
import { PayDTO } from '../../../dtos/PayDTO';

import {
  Container,
  Content,
  Header,
  TabsView,
	TabOperacao,
	TabDocumento,
	TabCliente,
	TabLancamento,
  FormView,
  Buttons,
	ClienteItem,
	TabConta,
	LoadingView,
} from './styles';

type GrauData = {
	value: string;
	label: string;
};
type ContaGrauData = {
	qtd_grau: number;
	grau_1: GrauData[];
	grau_2: GrauData[];
	grau_3: GrauData[];
	grau_4: GrauData[];
	grau_5: GrauData[];
};
type ClienteData = {
	cid: string;
	doc: string;
	id: string;
	nome: string;
	phone: string;
	avatar_url: string;
};
interface ModalParams {
	onClose: any;
	isVisible: boolean;
	lancamento: FinJsonDTO;
	handleForm: () => Promise<void>;
};

const ModalLancamentoEdit: React.FC<ModalParams> = ({
  onClose = () => {},
  isVisible,
	lancamento,
	handleForm
}) => {
  const formRef = useRef<FormHandles>(null);
	const formRefCliente = useRef<FormHandles>(null);
	const formRefConta = useRef<FormHandles>(null);
	const formRefLancamento = useRef<FormHandles>(null);

	const { user, company } = useAuth();
	const toast = useToast();

  const [visible, setVisible] = useState(isVisible);
	const [loading, setLoading] = useState(true);

	const [openAlert, setOpenAlert] = useState(false);
	const [textAlert, setTextAlert] = useState({ header: '', body: '', is_toast: false });

	const [tabIndex, setTabIndex] = useState(lancamento.id ? 1 : 0);
	const [disabledTabOperacao, setDisabledTabOperacao] = useState(false);
	const [disabledTabDocumento, setDisabledTabDocumento] = useState(true);
	const [disabledTabCliente, setDisabledTabCliente] = useState(true);
	const [disabledTabConta, setDisabledTabConta] = useState(true);
	const [disabledTabLancamento, setDisabledTabLancamento] = useState(true);

	const [lancamentoJson, setLancamentoJson] = useState<FinJsonDTO>({} as FinJsonDTO);

	const [radioOperacao, setRadioOperacao] = useState('');

	const [operacoes, setOperacoes] = useState<any[]>([]);
	const [tipoOps, setTipoOps] = useState<any[]>([]);
	const [filteredTipoOps, setFilteredTipodOps] = useState<any[]>([]);
	const [descriptionLength, setDescriptionLength] = useState(0);

	const [notCliente, setNotCliente] = useState(false);
	const [pesqClientes, setPesqCliente] = useState<ClienteDTO[]>([]);
	const [clienteSelected, setClienteSelected] = useState<ClienteDTO>({} as ClienteDTO);
	const [loadPesqCliente, setLoadPesqCliente] = useState(false);
	const [modalCadastroClienteVisible, setModalCadastroClienteVisible] = useState(false);

	const [grauContas, setGrauContas] = useState<ContaGrauData>({} as ContaGrauData);
	const [isDisabledBtnConta, setIsDisabledBtnConta] = useState(false);
	const [contas, setContas] = useState<ContaDTO[]>([]);

	const [accounts, setAccounts] = useState<any[]>([]);
	const [filteredAccounts, setFilteredAccounts] = useState<any[]>([]);
	const [pays, setPays] = useState<any[]>([]);
	const [filteredPays, setFilteredPays] = useState<any[]>([]);
	const [isDisabledBtnLanc, setIsDisabledBtnLanc] = useState(false);

	const [isLoadingTipoOps, setIsLoadingTipoOps] = useState(true);

	async function fetchDadosPagina() {
		try {
			const { data } = await api.get('/portal/financeiro/tabelas/L');

			setPays(data.pagamentos);
			setOperacoes(data.operacoes);
			setAccounts(data.contas);
			setTipoOps(data.tipo_ops);
			setGrauContas(data.grau_contas);

			if (lancamento.id) {
				const indexOp = data.operacoes.findIndex((op: any) => op.value === lancamento.operacao.id);
				const indexTypeOp = data.tipo_ops.findIndex((type_op: any) => type_op.value === lancamento.operacao.type_id);

				handleFilterTipoOpsAccounts(data.operacoes[indexOp]);

				// PEGA O ULTIMO LANCAMENTO PARA VER QUAL OPERAÇÃO QUE É
				const lastLanc = lancamento.lancamentos.length - 1;
				lancamento.lancamentos[lastLanc].vlr_cred > 0 
					? setRadioOperacao('C')
					: lancamento.lancamentos[lastLanc].vlr_deb > 0 && setRadioOperacao('D');

				formRef.current?.setData(lancamento);
				formRef.current?.setFieldValue('vlr_doc',
					lancamento.vlr_doc
						? formatPrice(lancamento.vlr_doc)
						: formatPrice(0));

				setDescriptionLength(lancamento.obs ? lancamento.obs.length : 0);

				if (lancamento.cliente) {
					lancamento.cliente.id = lancamento.cliente.id.toString();
					lancamento.cliente.nome = lancamento.cliente.nome.toLowerCase();

					setNotCliente(false);
					if (pesqClientes.length === 0) {
						setPesqCliente([...pesqClientes, lancamento.cliente]);
					};
					setClienteSelected(lancamento.cliente);
					
				} else {
					setNotCliente(true);
				};

				// para carregar os SelectInputs
				setTimeout(() => {
					formRef.current?.setFieldValue('op', data.operacoes[indexOp]);
					formRef.current?.setFieldValue('tipo_op', data.tipo_ops[indexTypeOp]);

					setDisabledTabOperacao(true);
					setDisabledTabDocumento(false);
					setDisabledTabCliente(false);
					setDisabledTabConta(false);
					setDisabledTabLancamento(false);

					lancamento.conta && setContas(lancamento.conta);
					setLancamentoJson(lancamento);
				}, 200);
			}

		} catch (error) {
			const isAppError = error instanceof AppError;
			const msg = isAppError ? error.message : 'Ocorreu um erro ao buscar dados da página.';

			toast({
				title: 'Dados da Página',
				description: msg,
				status: 'error',
				duration: 3000,
				position: 'top',
				isClosable: true,
				containerStyle: {
					marginTop: '5'
				}
			});
		}
		finally {
			setLoading(false)
		}
	};

  useEffect(() => {
		const fetch = async () => await fetchDadosPagina();
		fetch();
	}, []);

	const searchCliente = useCallback(async (form: any) => {
		try {
			formRefCliente.current?.setErrors({});

			const schema = Yup.object().shape({
				param: Yup.string().required('Parametro de pesquisa obrigatório'),
			});

			await schema.validate(form, { abortEarly: false });

			setLoadPesqCliente(true);
			setPesqCliente([]);

			const { param } = form;

			await api.get(`/portal/cliente/${param}`)
				.then(response => {
					setPesqCliente(response.data);
				})
				.finally(() => setLoadPesqCliente(false));
		} catch (err) {
			if (err instanceof Yup.ValidationError) {
				const errors = getValidationErrors(err);
				formRefCliente.current?.setErrors(errors);
			}
		}
	}, []);
 
	async function handleSubmitCliente() {
		if (!notCliente) {
			if (clienteSelected.id) {
				setLancamentoJson({ ...lancamentoJson, cliente: clienteSelected });
				setPesqCliente([...[], clienteSelected]);
				setDisabledTabDocumento(false);
				setTabIndex(2);
			}
		} else {
			const auxLancamento = lancamentoJson;
			// delete auxLancamento.cliente;

			setLancamentoJson({ ...auxLancamento });
			setPesqCliente([]);
			setDisabledTabDocumento(false);
			setTabIndex(2);
		};
	};

	async function handleSubmitDocumento(form: any, tab: number) {
		try {
			let auxValor = form.vlr_doc.replace('R$', '');
			auxValor = auxValor.replace(' ', '');
			auxValor = auxValor.replace('.', '');
			auxValor = auxValor.replace(',', '.');

			if (Number(auxValor) <= 0) {
				form.vlr_doc = '';
			};

			formRef.current?.setErrors({});

			const schema = Yup.object().shape({
				op: Yup.number().required('Operação obrigatório'),
				tipo_op: Yup.number().required('Tipo de operação obrigatório.'),
				doc: Yup.string().required('Valor do documento obrigatório'),
				vlr_doc: Yup.string().required('Valor do documento obrigatório'),
				data: Yup.string().required('Data de vencimento obrigatório'),
				obs: !notCliente ? Yup.string() : Yup.string().required('Obs é obrigatória quando não há cliente selecionado.') 
			});

			await schema.validate(form, {
				abortEarly: false,
			});

			const { doc, data, obs, op, tipo_op } = form;

			const indexOp = operacoes.findIndex(operacao => operacao.value === op);
			const auxOp = operacoes[indexOp];

			const indexTipoOp = tipoOps.findIndex(tipoOp => tipoOp.value === tipo_op);
			const auxTipoOp = tipoOps[indexTipoOp];

			const operacao: OperacaoDTO = {
				id: auxOp.value,
				caixa: auxOp.caixa,
				nome: auxOp.label,
				titulo: auxOp.titulo,
				type_id: auxTipoOp.value,
				type_nome: auxTipoOp.label
			};

			setLancamentoJson({
				...lancamentoJson,
				id: lancamento.id ? lancamento.id : uuid(),
				id_emp: company.id,
				doc,
				data,
				vlr_doc: Number(auxValor),
				operacao,
				obs,
				user_id: Number(user.id),
				user_nome: user.nome,
				lancamentos: lancamentoJson.lancamentos ? lancamentoJson.lancamentos : []
			});

			// Para Preencher os campos das contas na Aba Conta
			if (contas && contas.length === 0 && auxTipoOp.conta) {
				const arrayOp = auxTipoOp.conta.split('.');

				for (let i = 0; i < arrayOp.length; i++) {
					switch (i) {
						case 0:
							const indexConta1 = grauContas.grau_1.findIndex(item => item.value === arrayOp[i]);
							formRefConta.current?.setFieldValue('grau_1', grauContas.grau_1[indexConta1]);
							break;
						case 1:
							const indexConta2 = grauContas.grau_2.findIndex(item => item.value === arrayOp[i]);
							formRefConta.current?.setFieldValue('grau_2', grauContas.grau_2[indexConta2]);
							break;
						case 2:
							const indexConta3 = grauContas.grau_3.findIndex(item => item.value === arrayOp[i]);
							formRefConta.current?.setFieldValue('grau_3', grauContas.grau_3[indexConta3]);
							break;
						case 3:
							const indexConta4 = grauContas.grau_4.findIndex(item => item.value === arrayOp[i]);
							formRefConta.current?.setFieldValue('grau_4', grauContas.grau_4[indexConta4]);
							break;
						case 4:
							const indexConta5 = grauContas.grau_5.findIndex(item => item.value === arrayOp[i]);
							formRefConta.current?.setFieldValue('grau_5', grauContas.grau_5[indexConta5]);
							break;
						default:
							break;
					};
				};
				formRefConta.current?.setFieldValue('valor', formatPrice(auxValor));
			};

			setDisabledTabConta(false);
			setTabIndex(tab);
		}
		catch (error) {
			if (error instanceof Yup.ValidationError) {
				const errors = getValidationErrors(error);
				formRef.current?.setErrors(errors);
				setDisabledTabConta(true);
				setDisabledTabLancamento(true);
			}
		}
	};

	async function handleFilterTipoOpsAccounts(e: any) {
		try {
			if (e) {
				formRef.current?.setFieldValue('tipo_op', '');
				const filtered = tipoOps.filter(tipo_op => tipo_op.type_op === e.type_op);
				setFilteredTipodOps([...filtered]);

				formRefLancamento.current?.setFieldValue('type_pay', '');
				formRefLancamento.current?.setFieldValue('conta', '');

				const filterAccounts = accounts.filter(conta => conta.tip_conta === e.type_op);

				setFilteredAccounts([...filterAccounts]);

				if (filterAccounts.length === 1) {
					formRefLancamento.current?.setFieldValue('conta', filterAccounts[0]);
				};

				await handleUpdateDocumento();
			};
		} catch (error) {
			toast({
				title: 'Filtro Tipo op',
				description: 'Erro ao tentaer filtrar os tipos de operações',
				status: 'error',
				duration: 3000,
				position: 'top',
				isClosable: true,
				containerStyle: {
					marginTop: '5'
				}
			});
		} finally {
			setTimeout(() => {
				setIsLoadingTipoOps(false);
			}, 500);
		}
	};

	async function handleUpdateDocumento() {
		setContas([]);
		formRefConta.current?.reset();

		setLancamentoJson({ ...lancamentoJson, lancamentos: [] });
		formRefLancamento.current?.reset();

		setDisabledTabConta(true);
		setIsDisabledBtnConta(false);

		setDisabledTabLancamento(true);
		setIsDisabledBtnLanc(false);

		/* if (filteredAccounts.length === 1) {
			formRefLancamento.current?.setFieldValue('conta', filteredAccounts[0]);
		}; */
	};

	async function handleSubmitTabConta() {
		formRefLancamento.current?.setFieldValue('valor', formatPrice(lancamentoJson.vlr_doc));

		if (contas && contas.length > 0) {
			let resto = lancamentoJson.vlr_doc;
			contas.map(conta =>
				resto = Number((resto - (radioOperacao === 'C' ? conta.vlr_cred : conta.vlr_deb)).toFixed(2))
			);

			if (resto > 0) return;

			if (lancamentoJson.lancamentos.length > 0) {
				resto = 0;
				lancamentoJson.lancamentos.map(lanc =>
					resto = Number((resto - (radioOperacao === 'C' ? lanc.vlr_cred : lanc.vlr_deb)).toFixed(2))
				);

				if (resto > 0) formRefLancamento.current?.setFieldValue('valor', formatPrice(resto));
			} else {
				formRefLancamento.current?.setFieldValue('valor', formatPrice(lancamentoJson.vlr_doc));
			};
		};

		setIsDisabledBtnLanc(false);
		setDisabledTabLancamento(false);
		setTabIndex(4);
	};

	async function handleSubmitGrausConta(form: any) {
		try {
			formRefConta.current?.setErrors({});

			let schema;

			switch (grauContas.qtd_grau) {
				case 2:
					schema = Yup.object().shape({
						grau_1: Yup.string().required('Grau 1 obrigatório'),
						grau_2: Yup.string().required('Grau 2 obrigatório'),
						valor: Yup.string().required('Valor da conta obrigatório.'),
					});
					break;
				case 3:
					schema = Yup.object().shape({
						grau_1: Yup.string().required('Grau 1 obrigatório'),
						grau_2: Yup.string().required('Grau 2 obrigatório'),
						grau_3: Yup.string().required('Grau 3 obrigatório'),
						valor: Yup.string().required('Valor da conta obrigatório.'),
					});
					break;
				case 4:
					schema = Yup.object().shape({
						grau_1: Yup.string().required('Grau 1 obrigatório'),
						grau_2: Yup.string().required('Grau 2 obrigatório'),
						grau_3: Yup.string().required('Grau 3 obrigatório'),
						grau_4: Yup.string().required('Grau 4 obrigatório'),
						valor: Yup.string().required('Valor da conta obrigatório.'),
					});
					break;
				case 5:
					schema = Yup.object().shape({
						grau_1: Yup.string().required('Grau 1 obrigatório'),
						grau_2: Yup.string().required('Grau 2 obrigatório'),
						grau_3: Yup.string().required('Grau 3 obrigatório'),
						grau_4: Yup.string().required('Grau 4 obrigatório'),
						grau_5: Yup.string().required('Grau 5 obrigatório'),
						valor: Yup.string().required('Valor da conta obrigatório.'),
					});
					break;
				default:
					schema = Yup.object().shape({
						grau_1: Yup.string().required('Grau 1 obrigatório'),
						valor: Yup.string().required('Valor da conta obrigatório.'),
					});
					break;
			};

			await schema.validate(form, {
				abortEarly: false,
			});

			let numero = form.grau_1 ? `${form.grau_1}` : '';
			numero = form.grau_2 ? `${numero}.${form.grau_2}` : numero;
			numero = form.grau_3 ? `${numero}.${form.grau_3}` : numero;
			numero = form.grau_4 ? `${numero}.${form.grau_4}` : numero;
			numero = form.grau_5 ? `${numero}.${form.grau_5}` : numero;

			const exists = contas.findIndex(conta => conta.id === numero);
			if (exists !== -1) {
				toast({
					title: 'Conta Igual.',
					description: 'Já existe uma conta igual adicionada!',
					status: 'warning',
					duration: 5000,
					position: 'top-right',
					isClosable: true,
					containerStyle: {
						marginTop: '20'
					}
				});
				return;
			};

			let nome = '';

			if (form.grau_1) {
				const indexGrau1 = grauContas.grau_1.findIndex(grau => grau.value === form.grau_1);
				nome = grauContas.grau_1[indexGrau1].label;
			};
			if (form.grau_2) {
				const indexGrau2 = grauContas.grau_2.findIndex(grau => grau.value === form.grau_2);
				nome = `${nome} - ${grauContas.grau_2[indexGrau2].label}`;
			};
			if (form.grau_3) {
				const indexGrau3 = grauContas.grau_3.findIndex(grau => grau.value === form.grau_3);
				nome = `${nome} - ${grauContas.grau_3[indexGrau3].label}`;
			};
			if (form.grau_4) {
				const indexGrau4 = grauContas.grau_4.findIndex(grau => grau.value === form.grau_4);
				nome = `${nome} - ${grauContas.grau_4[indexGrau4].label}`;
			};
			if (form.grau_5) {
				const indexGrau5 = grauContas.grau_5.findIndex(grau => grau.value === form.grau_5);
				nome = `${nome} - ${grauContas.grau_5[indexGrau5].label}`;
			};

			const vlr_total = lancamentoJson.vlr_doc;

			let vlr = form.valor;
			vlr = await vlr.replace('R$', '').replace(' ', '').replace('.', '').replace(',', '.');
			vlr = Number(vlr);

			const auxConta = {
				id: numero,
				nome,
				percent: (vlr * 100) / vlr_total,
				vlr_cred: radioOperacao === 'C' ? vlr : 0,
				vlr_deb: radioOperacao === 'D' ? vlr : 0,
			};

			let resto = vlr_total;

			contas.map(conta => {
				resto = Number((resto - (radioOperacao === 'C' ? conta.vlr_cred : conta.vlr_deb)).toFixed(2));
			});

			resto = resto - vlr;

			setDisabledTabLancamento(true);
			setLancamentoJson({ ...lancamentoJson, lancamentos: [] });
			setContas([...contas, auxConta]);
			formRefConta.current?.reset();

			if (resto > 0) {
				setIsDisabledBtnConta(false);
				setIsDisabledBtnLanc(true);
				formRefConta.current?.setFieldValue('valor', formatPrice(resto));
			} else {
				setIsDisabledBtnConta(true);
				setIsDisabledBtnLanc(false);
			};
		} catch (err) {
			if (err instanceof Yup.ValidationError) {
				const errors = getValidationErrors(err);
				formRefConta.current?.setErrors(errors);
			}
		}
	};

	async function handleRemoveGrauConta(id: string) {
		const indexConta = contas.findIndex(conta => conta.id === id);
		const auxContas = contas;
		auxContas.splice(indexConta, 1);

		let resto = lancamentoJson.vlr_doc;
		auxContas.map(conta =>
			resto = Number((resto - (radioOperacao === 'C' ? conta.vlr_cred : conta.vlr_deb)).toFixed(2)));

		if (resto > 0) {
			setIsDisabledBtnConta(false);
			setIsDisabledBtnLanc(true);
			setDisabledTabLancamento(true);
			setLancamentoJson({ ...lancamentoJson, lancamentos: [] });
		} else {
			setIsDisabledBtnConta(true);
			setIsDisabledBtnLanc(false);
		};

		formRefConta.current?.setFieldValue('valor', formatPrice(resto));
		setContas([...auxContas]);
	};

	async function handleVerifValor(valor: string, tab: string) {
		let resto = lancamentoJson.vlr_doc;
		let campo;

		if (tab === 'conta') {
			contas.map(conta =>
				resto = resto - (radioOperacao === 'C' ? conta.vlr_cred : conta.vlr_deb));

			campo = document.getElementById('valor_conta');
		} else {
			lancamentoJson.lancamentos.map(lanc =>
				resto = resto - (radioOperacao === 'C' ? lanc.vlr_cred : lanc.vlr_deb));

			campo = document.getElementById('valor_lancamento');
		};

		if (formatPriceNumber(valor) > resto) {
			if (campo) {
				campo.textContent = `Valor superior ao resto do valor do titulo! (${formatPrice(resto)})`;
				campo.style.visibility = "visible";
				tab === 'conta' ? setIsDisabledBtnConta(true) : setIsDisabledBtnLanc(true);
			}
		} else {
			if (campo) {
				campo.style.visibility = "hidden";
				tab === 'conta' ? setIsDisabledBtnConta(false) : setIsDisabledBtnLanc(false);
				// setIsDisabledBtnConta(false);
			}
		}
	};

	async function handleSubmitLancamento(form: any) {
		try {
			formRefLancamento.current?.setErrors({});

			const schema = Yup.object().shape({
				conta: Yup.number().required('Conta obrigatório.'),
				type_pay: Yup.number().required('Pagamento obrigatório.'),
				valor: Yup.string().required('Valor da conta obrigatório.'),
			});

			await schema.validate(form, {
				abortEarly: false,
			});

			const { conta, type_pay, valor } = form;

			const newLancamento = {
				id: uuid(),
				ativo: true,
				caixa: {} as CaixaDTO,
				conta: [] as ContaDTO[],
				pay: {} as PayDTO,
				vlr_cred: radioOperacao === 'C' ? formatPriceNumber(valor) : 0,
				vlr_deb: radioOperacao === 'D' ? formatPriceNumber(valor) : 0,
				data: '',
				desconto: 0,
				juros: 0,
				multa: 0,
				taxa_antecip: 0,
				taxa_card: 0,
				vlr_pago_cred: 0,
				vlr_pago_deb: 0,
			};

			const indexCaixa = accounts.findIndex(cont => cont.value === conta);

			const auxCaixa = {
				compensado: true,
				id: accounts[indexCaixa].value,
				nome: accounts[indexCaixa].label,
				type_id: 0,
				type_nome: '',
				user_id: 0,
				user_nome: user.nome,
			};

			newLancamento.caixa = auxCaixa;

			const indexPay = pays.findIndex(pay => pay.id_pay === type_pay);
			newLancamento.pay = pays[indexPay];

			if (contas.length > 0) {
				let somaparcelas = 0;
				const aux = contas.map(contaa => {
					const perc = contaa.percent ? contaa.percent : 0;
					const newVlr = Number(((perc / 100) * formatPriceNumber(valor)).toFixed(2));

					somaparcelas = somaparcelas + newVlr;

					const auxConta = {
						id: contaa.id,
						nome: contaa.nome,
						percent: contaa.percent ? contaa.percent : 0,
						vlr_cred: contaa.vlr_cred > 0 ? newVlr : 0,
						vlr_deb: contaa.vlr_deb > 0 ? newVlr : 0
					};

					return auxConta;
				});

				if (somaparcelas > formatPriceNumber(valor)) {
					const resto = Number((somaparcelas - formatPriceNumber(valor)).toFixed(2));
					aux[0].vlr_cred = aux[0].vlr_cred > 0 ? (aux[0].vlr_cred - resto) : 0;
					aux[0].vlr_deb = aux[0].vlr_deb > 0 ? (aux[0].vlr_cred - resto) : 0;
				} else if (somaparcelas < formatPriceNumber(valor)) {
					const resto = Number((formatPriceNumber(valor) - somaparcelas).toFixed(2));
					aux[0].vlr_cred = aux[0].vlr_cred > 0 ? (aux[0].vlr_cred + resto) : 0;
					aux[0].vlr_deb = aux[0].vlr_deb > 0 ? (aux[0].vlr_cred + resto) : 0;
				};

				newLancamento.conta = aux;
			};

			const auxLancamentos = lancamentoJson.lancamentos;
			auxLancamentos.push(newLancamento);

			setLancamentoJson({ ...lancamentoJson, lancamentos: auxLancamentos });
			formRefLancamento.current?.reset();

			let resto = lancamentoJson.vlr_doc;
			auxLancamentos.map(lanc =>
				resto = Number((resto - (radioOperacao === 'C' ? lanc.vlr_cred : lanc.vlr_deb)).toFixed(2))
			);

			if (resto > 0) {
				setIsDisabledBtnLanc(false);
				formRefLancamento.current?.setFieldValue('valor', formatPrice(resto));
			} else {
				setIsDisabledBtnLanc(true);
			};

		} catch (err) {
			if (err instanceof Yup.ValidationError) {
				const errors = getValidationErrors(err);
				formRefLancamento.current?.setErrors(errors);
			}
		}
	};

	async function handleRemoveLancamento(id: string) {
		const indexLancamento = lancamentoJson.lancamentos.findIndex(conta => conta.id === id);
		const auxLancamentos = lancamentoJson.lancamentos;
		auxLancamentos.splice(indexLancamento, 1);

		let resto = lancamentoJson.vlr_doc;
		auxLancamentos.map(lanc =>
			resto = Number((resto - (radioOperacao === 'C' ? lanc.vlr_cred : lanc.vlr_deb)).toFixed(2))
		);

		if (resto > 0) {
			setIsDisabledBtnLanc(false);
		} else {
			setIsDisabledBtnLanc(true);
		};

		formRefLancamento.current?.setFieldValue('valor', formatPrice(resto));
		setLancamentoJson({...lancamentoJson, lancamentos: auxLancamentos });
	};

	function handleFilterPays(e: any) {
		if (e) {
			formRefLancamento.current?.setFieldValue('type_pay', '');
			const filtered = pays.filter(pay => pay.tip_conta === e.tip_conta);
			setFilteredPays(filtered);
		};
	};

	async function handleSubmitCadastro() {
		try {
			// setLoading(true);

			let resto = lancamentoJson.vlr_doc;
			lancamentoJson.lancamentos.map(lanc =>
				resto = Number((resto - (radioOperacao === 'C' ? lanc.vlr_cred : lanc.vlr_deb)).toFixed(2)));

			if (resto > 0) {
				setLoading(false);
				return
			};

			setLancamentoJson({ ...lancamentoJson, conta: contas });
			const auxLancamentoJson = { ...lancamentoJson, conta: contas };

			await api.post('/portal/lancamento/store', { lancamento: auxLancamentoJson });

			toast({
				title: 'Lançamento.',
				description: 'Você salvou um novo Lançamento!',
				status: 'success',
				duration: 5000,
				position: 'top',
				isClosable: true,
				containerStyle: {
					marginTop: '5'
				}
			});

		} catch (error) {
			toast({
				title: 'Erro',
				description: `Tente novamente mais tarde - ${error}`,
				status: 'error',
				duration: 5000,
				position: 'top',
				isClosable: true,
				containerStyle: {
					marginTop: '5'
				}
			});

		} finally {
			/* await handleForm();
			setVisible(false);
			onClose();
			setLoading(false);*/
		}
	};

	function handleCancel(is_toast: boolean) {
		if (!is_toast) {
			const r = window.confirm(
				'Você não salvou suas alterações!\nDeseja sair sem salvar?',
			);

			if (r) {
				formRef.current?.reset();
				setVisible(false);
				onClose();
			} else { return; };
		};

		toast({
			title: `${lancamento.id ? 'Edição' : 'Criação'} Lançamento.`,
			description: `${lancamento.id ? 'Edição' : 'Criação'} do lançamento cancelada!`,
			status: 'warning',
			duration: 3000,
			position: 'top',
			isClosable: true,
			containerStyle: {
				marginTop: '5'
			}
		});

		formRef.current?.reset();
		setVisible(false);
		onClose();
	};

  return (
    <Container id="ModalLancamentoEdit">
      <Content className={`${visible ? 'active' : ''}`}>
				{loading && (
					<LoadingView>
						<img src={load} alt="LoadingView" />
					</LoadingView>
				)}

				<Header style={{ display: 'flex', justifyContent: 'space-between' }}>
					<Flex align="center" ml={-4}>
						<Avatar
							name='cliente'
							src='https://safetycloud.blob.core.windows.net/razio-avatar/user.png'
							size="md"
							mt={-1}
						/>
						&nbsp;&nbsp;
						<Text fontSize={[16, 20]} fontWeight={500} textTransform="capitalize">
							{lancamentoJson.cliente ? lancamentoJson.cliente.nome : '--'}
						</Text>
					</Flex>

					<Flex flexDir="column">
						{radioOperacao !== '' && (
							<Flex
								align="center"
								borderRadius="full"
								background={radioOperacao === 'C' ? 'blue.200' : 'red.100'}
								color={radioOperacao === 'C' ? 'blue.900' : 'red.900'}
								px={2}
								pl={4}
							>
								<Text
									fontSize={[lancamentoJson.vlr_doc ? 16 : 20, lancamentoJson.vlr_doc ? 16 : 24]}
									fontWeight={600}
								>
									{radioOperacao === 'C' ? `Crédito` : 'Débito'}
								</Text>

								{radioOperacao === 'C' ? (
									<Icon as={FiPlus} fontSize={[23, 25]} />
								) : (
									<Icon as={FiMinus} fontSize={[23, 25]} />
								)}
							</Flex>
						)}

						{lancamentoJson.vlr_doc && (
							<Text
								fontSize={[15, 17]}
								fontWeight={600}
								textAlign="center"
								pt={[0, 1]}
							>
								{formatPrice(lancamentoJson.vlr_doc)}
							</Text>
						)}
					</Flex>
				</Header>

				<TabsView>
					<Tabs className="tabs" index={tabIndex}>
						<TabList className="tab-list" mt={-2} overflowX="auto" scrollBehavior="smooth">
							<Tab
								className="tab"
								isDisabled={disabledTabOperacao}
								// onClick={() => handleSubmitDocumento(formRef.current?.getData(), 2)}
								onClick={() => setTabIndex(0)}
							>
								Operação
							</Tab>

							<Tab
								className="tab"
								isDisabled={disabledTabCliente}
								onClick={() => {
									formRef.current?.setFieldError('obs', '');
									setTabIndex(1);
								}}
							>Cliente</Tab>

							<Tab
								className="tab"
								isDisabled={disabledTabDocumento}
								onClick={() => setTabIndex(2)}
							>Documento</Tab>

							<Tab
								className="tab"
								isDisabled={disabledTabConta}
								onClick={() => setTabIndex(3)}
							>Conta</Tab>

							<Tab
								className="tab"
								isDisabled={disabledTabLancamento}
								onClick={() => setTabIndex(4)}
							>Lançamentos</Tab>
						</TabList>

						<TabPanels className="tab-panels">
							<TabOperacao className="tab-panel">
								<div className="tab-content">
									<Header>
										<h1>Lançamento</h1>
										<h2>Escolha aqui a operação do titulo débito ou crédito.</h2>
									</Header>

									<Stack
										spacing={4}
										direction={['column', 'column', 'row']}
										h={["150px", "150px" ,"90px"]}
										w="100%"
										mt={4}
									>
										<Button
											w="100%"
											h="100%"
											mr={1}
											colorScheme="blue"
											fontSize={20}
											borderRadius={10}
											onClick={() => {
												setRadioOperacao('C');
												// setDisabledTabDocumento(false);
												setDisabledTabCliente(false);
												setDisabledTabOperacao(true);
												setTabIndex(1);
											}}
										>
											CRÉDITO &nbsp;&nbsp;
											{radioOperacao === 'C' && (
												<Icon as={FiCheckCircle} fontSize={30} />
											)}
										</Button>

										<Button
											w="100%"
											h="100%"
											ml={1}
											colorScheme="red"
											fontSize={20}
											borderRadius={10}
											onClick={() => {
												setRadioOperacao('D');
												// setDisabledTabDocumento(false);
												setDisabledTabCliente(false);
												setDisabledTabOperacao(true);
												setTabIndex(1);
											}}
										>
											DÉBITO &nbsp;&nbsp;
											{radioOperacao === 'D' && (
												<Icon as={FiCheckCircle} fontSize={30} />
											)}
										</Button>
									</Stack>

									<Buttons>
										<Flex flexDir="column" pl={4} py={0}>
											<Text fontSize={[10, 14]} fontWeight={400}>Usuário:</Text>
											<Text pl={2} fontSize={[11, 15]} fontWeight={500}>{user.nome}</Text>
										</Flex>

										<Flex className="buttons">
											<button
												type="button"
												className="button-cancel"
												onClick={() => {
													setTextAlert({
														header: `Cancelar ${lancamento.id ? 'Alteração' : 'Criação'} do Lançamento!`,
														body: 'Você não salvou suas alterações!' + "\n" + 'Deseja sair sem salvar?',
														is_toast: true,
													});
													setOpenAlert(true);
												}}
											>
												Cancelar
											</button>
										</Flex>
									</Buttons>
								</div>
							</TabOperacao>

							<TabCliente className="tab-panel">
								<div className="tab-content">
									<Header>
										<h1>Cliente</h1>
										<h2>Adicione ou altera aqui o cliente.</h2>
									</Header>

									{/* SWITCH - SEM CLIENTE */}
									<Flex w="100%" justify="space-between" align="center">
										<Flex
											align="center"
											background="gray.50"
											borderRadius={20}
											px={4} py={1} mt={3} mb={2}
										>
											<FormLabel htmlFor='sem_cliente' mb='0'>sem cliente.</FormLabel>

											<Switch
												id="sem_cliente"
												isChecked={notCliente}
												onChange={() => {
													setNotCliente(!notCliente);
													setClienteSelected({} as ClienteData);
													setPesqCliente([]);
													// setDisabledTabDocumento(true);
													// setDisabledTabConta(true);
													// setDisabledTabLancamento(true);
												}}
											/>
										</Flex>

										{/* BUTTON NOVO */}
										<Flex flexDir="column" justify="flex-end">
											<button
												type="button"
												className="button-save"
												onClick={() => setModalCadastroClienteVisible(true)}
												style={{ display: 'flex', alignItems: 'center', margin: 0 }}
											>
												<Icon as={FiPlus} fontSize={18} />&nbsp;
												<Text>Novo</Text>
											</button>
										</Flex>
									</Flex>

									{/* FORMULÁRIO DE PESQUISA DE CLIENTE */}
									<FormView ref={formRefCliente} onSubmit={searchCliente}>
										<Stack spacing={2} direction="row" w="100%" pb={4}>
											{/* CLIENTE */}
											<div className="input">
												<p>Cliente</p>
												<Input
													name="param"
													type="text"
													placeholder="pesquisa"
													disabled={notCliente}
													containerStyle={{ padding: '5px 10px' }}
												/>
											</div>

											<Flex flexDir="column" justify="flex-end">
												<button
													type="submit"
													className="button-save"
													disabled={notCliente}
													style={{ display: 'flex', alignItems: 'center', margin: '0'}}
												>
													<Icon as={FiSearch} fontSize={18} />&nbsp;
													<Text>Buscar</Text>
												</button>
											</Flex>
										</Stack>
									</FormView>

									{pesqClientes.length > 0 ? (
										<SimpleGrid
											display="block"
											borderWidth={2}
											borderColor="gray.100"
											borderRadius={6}
											columns={1}
											spacing={4}
											overflowY="scroll"
											scrollBehavior="smooth"
											mb={10}
										>
											{pesqClientes.map((cliente: any) => {
												return (
													<ClienteItem key={cliente.id} selected={cliente.id === clienteSelected.id}>
														<Flex justify="space-between" align="center">
															<Flex w={["25%", "12%"]}>
																<Image
																	src={
																		cliente.avatar_url
																			? cliente.avatar_url
																			: 'https://safetycloud.blob.core.windows.net/cashback-promocoes/placeholder-image.png'
																	}
																	alt="Imagem Perfil"
																	boxSize="50px"
																	borderRadius="full"
																	objectFit="cover"
																/>
															</Flex>

															<Flex flexDir="column" w="100%">
																<Text fontWeight={600} color={cliente.id === clienteSelected.id ? "white" : "blue.500"}>
																	{cliente.nome}
																</Text>

																<Text fontSize={[12, 13]} fontWeight={500} color={cliente.id === clienteSelected.id ? "white" : "gray.800"}>
																	{cliente.id}
																</Text>

																<Stack direction={["column", "row"]} spacing={[0, 4]}>
																	<h2>
																		Doc: <span>{cliente.doc ? cliente.doc : "--"}</span>
																	</h2>

																	<h2>
																		Tel: <span>{cliente.phone ? cliente.phone : "--"}</span>
																	</h2>
																</Stack>
																
																<h2>
																	Cidade: <span>{cliente.cid ? cliente.cid : "--"}</span>
																</h2>
															</Flex>

															<Flex w={["2%", "10%"]} justify="flex-end">
																{clienteSelected.id && cliente.id === clienteSelected.id ? (
																	<Icon as={FiCheckCircle} />
																) : (
																	<Icon
																		as={FiArrowRight}
																		cursor="pointer"
																		onClick={() => setClienteSelected(cliente)}
																	/>
																)}
															</Flex>
														</Flex>
													</ClienteItem>
												)
											})}
										</SimpleGrid>
									) : (
										<Flex justify="center" >
											{loadPesqCliente ? (
												<Spinner
													thickness='4px'
													speed='0.65s'
													emptyColor='gray.50'
													color='blue.500'
													size='lg'
													m={4}
												/>
											) : (
												<Text>Nenhum cliente encontrado</Text>
											)}
										</Flex>
									)}

									<Buttons>
										<Flex flexDir="column" pl={4} py={0}>
											<Text fontSize={[10, 14]} fontWeight={400}>Usuário:</Text>
											<Text pl={2} fontSize={[11, 15]} fontWeight={500}>{user.nome}</Text>
										</Flex>

										<Flex className="buttons">
											<button
												type="button"
												className="button-cancel"
												onClick={() => {
													setTextAlert({
														header: `Cancelar ${lancamento.id ? 'Alteração' : 'Criação'} do Lançamento!`,
														body: 'Você não salvou suas alterações!' + "\n" + 'Deseja sair sem salvar?',
														is_toast: true,
													});
													setOpenAlert(true);
												}}
											>
												Cancelar
											</button>

											<button
												type="button"
												className="button-save"
												onClick={handleSubmitCliente}
											>
												Proximo
											</button>
										</Flex>
									</Buttons>
								</div>
							</TabCliente>

							<TabDocumento className="tab-panel" overflowY="auto" scrollBehavior="smooth">
								<div className="tab-content">
									<Header style={{ marginBottom: '0px' }}>
										<h1>Lançamento</h1>
										<h2>Dados do lançamento</h2>
									</Header>

									<Divider mt={0} />

									<FormView ref={formRef} onSubmit={(e) => handleSubmitDocumento(e, 3)}>
										{/* OPERACAO - TIPO OPERAÇÃO */}
										<Stack w="100%" spacing={[0, 4]} direction={['column', 'column', 'row']}>
											{/* OPERACAO */}
											<div className="input">
												<p>Operação <span>(obrigatório)</span></p>
												<SelectInput
													name="op"
													placeholder="Operação"
													options={operacoes}
													onChange={(e: any) => {
														setIsLoadingTipoOps(true);
														handleFilterTipoOpsAccounts(e);
													}}
												/>
											</div>

											{/* TIPO OPERAÇÃO */}
											<div className="input">
												<p>Tipo de operação <span>(obrigatório)</span></p>
												<SelectInput
													name="tipo_op"
													placeholder="Tipo de operação"
													isLoading={isLoadingTipoOps}
													options={filteredTipoOps}
													onChange={handleUpdateDocumento}
												/>
											</div>
										</Stack>

										{/* NÚMERO DOC - VALOR */}
										<Stack w="100%" spacing={[0, 4]} direction={['column', 'column', 'row']}>
											{/* NÚMERO DOC */}
											<div className="input">
												<p>Nº Documento <span>(obrigatório)</span></p>
												<Input
													name="doc"
													type="text"
													placeholder="Número do título"
													onChange={handleUpdateDocumento}
													containerStyle={{ padding: '6px 0 6px 10px' }}
												/>
											</div>

											{/* VALOR */}
											< div className="input">
												<p>Valor <span>(obrigatório)</span></p>
												<Input
													name="vlr_doc"
													type="text"
													placeholder="Valor do título"
													onChange={(e: any) => {
														e.target.value && formatInputMoeda('vlr_doc', formRef);
														handleUpdateDocumento();
													}}
													containerStyle={{ padding: '6px 0 6px 10px' }}
												/>
											</div>
										</Stack>

										{/* DATA EMISSÃO - OBS */}
										<Stack w="100%" spacing={[0, 4]} direction={['column', 'column', 'row']}>
											{/* DATA EMISSÃO */}
											<div className="input">
												<p>Data de Emissão <span>(obrigatório)</span></p>
												<InputDate
													name="data"
													placeholder="data do título"
													defaultValue={format(new Date(), "Y'-'MM'-'dd", { locale: ptBR })}
													onChange={handleUpdateDocumento}
													containerStyle={{ padding: '6px 10px' }}
												/>
											</div>

											{/* OBS */}
											<div className="input">
												<p>Observação</p>
												<InputTextArea
													name="obs"
													placeholder="Observação do título"
													rows={3}
													cols={4}
													max={5000}
													onChange={(e: any) => {
														setDescriptionLength(e.target.value.length);
														handleUpdateDocumento();
													}}
													containerStyle={{ padding: '6px 0 6px 10px' }}
												/>

												<span>
													{descriptionLength}/5000
													caracteres
												</span>
											</div>
										</Stack>

										<Buttons>
											<Flex flexDir="column" pl={4} py={0}>
												<Text fontSize={[10, 14]} fontWeight={400}>Usuário:</Text>
												<Text pl={2} fontSize={[11, 15]} fontWeight={500}>{user.nome}</Text>
											</Flex>

											<Flex className="buttons">
												<button
													type="button"
													className="button-cancel"
													onClick={() => {
														setTextAlert({
															header: `Cancelar ${lancamento.id ? 'Alteração' : 'Criação'} do Lançamento!`,
															body: 'Você não salvou suas alterações!' + "\n" + 'Deseja sair sem salvar?',
															is_toast: true,
														});
														setOpenAlert(true);
													}}
												>
													Cancelar
												</button>

												<button type="submit" className="button-save">
													Próximo
												</button>
											</Flex>
										</Buttons>
									</FormView>
								</div>
							</TabDocumento>

							<TabConta className="tab-panel">
								<div className="tab-content">
									<Header>
										<h1>Conta</h1>
										<h2>Adicione ou altera aqui uma conta.</h2>
									</Header>

									<Divider mt={0} />

									<FormView ref={formRefConta} onSubmit={handleSubmitGrausConta}>
										{/* GRAU 1 - GRAU 2 */}
										<Stack w="100%" spacing={[0, 4]} direction={['column', 'column', 'row']}>
											{/* GRAU 1 */}
											{grauContas?.grau_1?.length > 0 && (
												<div className="input">
													<p>Grau 1 <span>(obrigatório)</span></p>
													<SelectInput
														name="grau_1"
														placeholder="Selecione grau 1"
														options={grauContas.grau_1}
													/>
												</div>
											)}

											{/* GRAU 2 */}
											{grauContas?.grau_2?.length > 0 && (
												<div className="input">
													<p>Grau 2 <span>(obrigatório)</span></p>
													<SelectInput
														name="grau_2"
														placeholder="Selecione grau 2"
														options={grauContas.grau_2}
													/>
												</div>
											)}
										</Stack>

										{/* GRAU 3 - GRAU 4 */}
										{grauContas.qtd_grau >= 3 && (
											<Stack w="100%" spacing={[0, 4]} direction={['column', 'column', 'row']} mt={-3}>
												{/* GRAU 3 */}
												{grauContas?.grau_3?.length > 0 && (
													<div className="input">
														<p>Grau 3 <span>(obrigatório)</span></p>
														<SelectInput
															name="grau_3"
															placeholder="Selecione grau 3"
															options={grauContas?.grau_3}
														/>
													</div>
												)}

												{/* GRAU 4 */}
												{grauContas?.grau_4?.length > 0 && (
													<div className="input">
														<p>Grau 4 <span>(obrigatório)</span></p>
														<SelectInput
															name="grau_4"
															placeholder="Selecione grau 4"
															options={grauContas?.grau_4}
														/>
													</div>
												)}
											</Stack>
										)}

										{/* GRAU 5 */}
										{grauContas?.qtd_grau === 5 && (
											<Stack w="100%" spacing={[0, 4]} direction={['column', 'column', 'row']} mt={-3}>
												{/* GRAU 5 */}
												<div className="input">
													<p>Grau 5 <span>(obrigatório)</span></p>
													<SelectInput
														name="grau_5"
														placeholder="Selecione grau 5"
														options={grauContas.grau_5}
													/>
												</div>
											</Stack>
										)}

										{/* VALOR - BTN ADD  */}
										<Stack spacing={[0, 4]} direction="row" w="100%" mt={-2}>
											<div className="input">
												<p>Valor</p>
												<Input
													name="valor"
													placeholder="Valor"
													onChange={(e: any) => {
														formatInputMoeda('valor', formRefConta);
														handleVerifValor(e.target.value, 'conta');
													}}
													containerStyle={{ padding: '7px 10px' }}
												/>
											</div>

											<Flex flexDir="column" justify="flex-end" w="100%" h="100%">
												<button
													type="submit"
													className="button-save"
													disabled={isDisabledBtnConta}
													style={{ padding: '8px 20px', width: '9rem' }}
												>
													Adicionar
												</button>
											</Flex>
										</Stack>

										{/* MSG Valor Superior  */}
										<Flex w="100%" pt={0.5}>
											<Text
												id="valor_conta"
												fontSize={12}
												color="red.900"
												visibility="hidden"
											>
												Valor superior ao valor do Documento!
											</Text>
										</Flex>
									</FormView>

									{contas?.length > 0 && (
										<Flex
											flexDir="column"
											borderWidth={2}
											borderColor="gray.100"
											borderRadius={6}
											px={2}
											my={2}
											mb={10}
											h="auto"
											overflowY="scroll" scrollBehavior="smooth"
										>
											<Table size="sm">
												<Thead>
													<Tr>
														<Th></Th>
														<Th>Número</Th>
														<Th>Descrição</Th>
														<Th isNumeric>Valor</Th>
													</Tr>
												</Thead>

												<Tbody>
													{contas.map(conta => {
														return (
															<Tr key={conta.id}>
																<Td pr={0} mr={0}>
																	<Icon
																		as={FiTrash2}
																		color="red.800"
																		fontSize={18}
																		cursor="pointer"
																		onClick={() => handleRemoveGrauConta(conta.id)}
																	/>
																</Td>
																<Td>{conta.id}</Td>
																<Td>{conta.nome}</Td>
																<Td isNumeric>
																	{formatPrice(conta.vlr_cred !== 0 ? conta.vlr_cred : conta.vlr_deb)}
																</Td>
															</Tr>
														)
													})}
												</Tbody>

												<Tfoot>
													<Tr>
														<Th></Th>
														<Th>Número</Th>
														<Th>Descrição</Th>
														<Th isNumeric>Valor</Th>
													</Tr>
												</Tfoot>
											</Table>
										</Flex>
									)}

									<Buttons>
										<Flex flexDir="column" pl={4} py={0}>
											<Text fontSize={[10, 14]} fontWeight={400}>Usuário:</Text>
											<Text pl={2} fontSize={[11, 15]} fontWeight={500}>{user.nome}</Text>
										</Flex>

										<Flex className="buttons">
											<button
												type="button"
												className="button-cancel"
												onClick={() => {
													setTextAlert({
														header: `Cancelar ${lancamento.id ? 'Alteração' : 'Criação'} do Lançamento!`,
														body: 'Você não salvou suas alterações!' + "\n" + 'Deseja sair sem salvar?',
														is_toast: true,
													});
													setOpenAlert(true);
												}}
											>
												Cancelar
											</button>

											<button
												type="button"
												className="button-save"
												onClick={handleSubmitTabConta}
											>
												Proximo
											</button>
										</Flex>
									</Buttons>
								</div>
							</TabConta>

							<TabLancamento className="tab-panel" overflowY="scroll" scrollBehavior="smooth">
								<div className="tab-content">
									<Header>
										<h1>Lançamentos</h1>
										<h2>Adicione ou altera aqui os lançamentos.</h2>
									</Header>

									<Divider mt={0} />

									<FormView ref={formRefLancamento} onSubmit={handleSubmitLancamento}>
										{/* CONTA - TIPO DE PAGAMENTO */}
										<Stack w="100%" spacing={[0, 4]} direction={['column', 'column', 'row']}>
											{/* CONTA */}
											<div className="input">
												<p>Conta / Caixa <span>(obrigatório)</span></p>
												<SelectInput
													name="conta"
													placeholder="Conta/Caixa"
													options={filteredAccounts}
													onChange={(e: any) => handleFilterPays(e)}
												/>
											</div>

											{/* TIPO DE PAGAMENTO */}
											<div className="input">
												<p>Tipo de pagamento <span>(obrigatório)</span></p>
												<SelectInput
													name="type_pay"
													placeholder="Pagamentos"
													options={filteredPays}
												/>
											</div>
										</Stack>

										{/* VALOR - BTN ADD  */}
										<Stack spacing={[0, 4]} direction="row" w="100%" mt={-2}>
											<div className="input">
												<p>Valor</p>
												<Input
													name="valor"
													placeholder="Valor"
													onChange={(e: any) => {
														formatInputMoeda('valor', formRefLancamento);
														handleVerifValor(e.target.value, 'lancamento');
													}}
													containerStyle={{ padding: '7px 10px' }}
												/>
											</div>

											<Flex flexDir="column" justify="flex-end" w="100%" h="100%">
												<button
													type="submit"
													className="button-save"
													disabled={isDisabledBtnLanc}
													style={{ padding: '8px 0px', width: '9rem' }}
												>
													Adicionar
												</button>
											</Flex>
										</Stack>

										{/* MSG Valor Superior  */}
										<Flex w="100%" pt={0.5}>
											<Text
												id="valor_lancamento"
												fontSize={12}
												color="red.900"
												visibility="hidden"
											>
												Valor superior ao valor do Documento!
											</Text>
										</Flex>
									</FormView>

									{lancamentoJson.lancamentos?.length > 0 && (
										<Flex flexDir="column" w="100%" h="100%">
											<Text fontSize={18} fontWeight={500} mt={1} ml={2}>Lançamentos</Text>

											<Accordion
												allowMultiple
												borderWidth={2}
												borderColor="gray.100"
												borderRadius={6}
												p={2}
												mb="50px"
											>
												{lancamentoJson.lancamentos.map((lanc) => {
													return (
														<Stack key={lanc.id} w="100%" direction="row" spacing={2} align="center" mb={2}>
															<Flex
																bg={lanc.vlr_cred > 0 ? "blue.100" : 'red.100'}
																px={2} py={2.5}
																borderRadius={6}
															>
																<Icon
																	as={FiTrash2}
																	color="red.800"
																	fontSize={20}
																	cursor="pointer"
																	onClick={() => handleRemoveLancamento(lanc.id)}
																/>
															</Flex>

															<AccordionItem
																bg={lanc.vlr_cred > 0 ? 'blue.100' : 'red.100'}
																border={0}
																borderRadius={6}
																w="100%"
																p={["0px !important", "0px !important"]}
															>
																<AccordionButton
																	m={["0px !important", "0px !important"]}
																	p={["0px !important", "0px !important"]}
																	_hover={{ background: "transparent" }}
																>
																	<Stack
																		direction="row"
																		justify="space-between"
																		align="center"
																		w="100%"
																		m={["0px !important", "0px !important"]}
																		p={["10px !important", "9px !important"]}
																	>
																		<Flex
																			align="center"
																			fontWeight={500}
																			p={0}
																		>
																			<Text>{lanc.caixa.nome}</Text>
																		</Flex>

																		<Flex fontWeight={500} align="center">
																			<Flex align="center">
																				<Flex w="27px" h="24px" align="center">
																					{lanc.pay.url_pay && (
																						<Image src={lanc.pay.url_pay} objectFit="cover" w="20px" h="15px" mr={2} />
																					)}
																				</Flex>
																				<Text>{lanc.pay.name_pay}</Text>
																			</Flex>
																		</Flex>

																		<Flex align="center" fontWeight={500}>
																			<Text>{formatPrice(lanc.vlr_cred > 0 ? lanc.vlr_cred : lanc.vlr_deb)}</Text>
																			<AccordionIcon color="blue.500" />
																		</Flex>
																	</Stack>
																</AccordionButton>

																<AccordionPanel px={2} pt={-2} pb={1}>
																	{lanc.conta?.map(conta => {
																		return (
																			<Flex key={conta.id} flexDir={["column", "row"]} justify="space-between" p={2} bg="gray.100" my={1} borderRadius={6}>
																				<Text fontSize={[14, 15]} fontWeight={500}>{conta.id}</Text>
																				<Text fontSize={[14, 15]} fontWeight={500}>{conta.nome}</Text>
																				<Text fontSize={[14, 15]} fontWeight={500}>{conta.vlr_cred > 0
																					? formatPrice(conta.vlr_cred)
																					: formatPrice(conta.vlr_deb)
																				}
																				</Text>
																			</Flex>
																		)
																	})}
																</AccordionPanel>
															</AccordionItem>
														</Stack>
													)
												})}
											</Accordion>
										</Flex>
									)}

									<Buttons>
										<Flex flexDir="column" pl={4} py={0}>
											<Text fontSize={[10, 14]} fontWeight={400}>Usuário:</Text>
											<Text pl={2} fontSize={[11, 15]} fontWeight={500}>{user.nome}</Text>
										</Flex>

										<Flex className="buttons">
											<button
												type="button"
												className="button-cancel"
												onClick={() => {
													setTextAlert({
														header: `Cancelar ${lancamento.id ? 'Alteração' : 'Criação'} do Lançamento!`,
														body: 'Você não salvou suas alterações!' + "\n" + 'Deseja sair sem salvar?',
														is_toast: true,
													});
													setOpenAlert(true);
												}}
											>
												Cancelar
											</button>

											<button
												type="button"
												className="button-save"
												onClick={handleSubmitCadastro}
											>
												Proximo
											</button>
										</Flex>
									</Buttons>
								</div>
							</TabLancamento>
						</TabPanels>
					</Tabs>
				</TabsView>
      </Content>

			{modalCadastroClienteVisible && (
				<ModalCadastroCliente
					isVisible={modalCadastroClienteVisible}
					onClose={setModalCadastroClienteVisible}
					searchCliente={searchCliente}
				/>
			)}

			{openAlert && (
				<Alert
					isOpen={openAlert}
					onRequestClose={setOpenAlert}
					textAlert={textAlert}
					execFunction={handleCancel}
				/>
			)}
    </Container>
  );
};

export default ModalLancamentoEdit;
